/**
 * Kleine Bausteine des Produkt-Editors: Abschnitt, Feld, Zahleneingabe.
 * Industrial-Editorial (DESIGN.md): Slate-Flächen, Navy als Marke, kein Gold
 * im Editor, 44-px-Touchziele, tabular-nums für Zahlen.
 */
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

export function Section({ icon: Icon, title, hint, action, children, className }) {
  return (
    <section className={cn('rounded-xl border border-slate-200 bg-slate-50 p-4 space-y-4', className)}>
      <header className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="font-display text-sm font-bold tracking-tight text-brand-950 flex items-center gap-2">
            {Icon && <Icon className="w-4 h-4 text-slate-500" />}
            {title}
          </h3>
          {hint && <p className="text-xs text-slate-500 mt-0.5">{hint}</p>}
        </div>
        {action}
      </header>
      {children}
    </section>
  );
}

export function Field({ label, children, hint, error, className, htmlFor }) {
  return (
    <div className={cn('space-y-1', className)}>
      <label htmlFor={htmlFor} className="block text-[11px] font-semibold uppercase tracking-wide text-slate-500">
        {label}
      </label>
      {children}
      {hint && !error && <p className="text-[11px] text-slate-400">{hint}</p>}
      {error && <p className="text-[11px] text-red-600">{error}</p>}
    </div>
  );
}

/** Text-Input für Dezimalzahlen (deutsches Komma erlaubt), rechtsbündig */
export function NumInput({ className, invalid, ...props }) {
  return (
    <Input
      inputMode="decimal"
      autoComplete="off"
      className={cn('min-h-[44px] text-right tabular-nums', invalid && 'border-red-500 focus-visible:ring-red-500', className)}
      {...props}
    />
  );
}

export function TextInput({ className, invalid, ...props }) {
  return (
    <Input
      autoComplete="off"
      className={cn('min-h-[44px]', invalid && 'border-red-500 focus-visible:ring-red-500', className)}
      {...props}
    />
  );
}

export const fmtEUR = (v) => (v == null || v === '' || Number.isNaN(Number(v))
  ? '—'
  : Number(v).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }));
